export default () => (
  <svg width='6' height='8' viewBox='0 0 6 8' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path d='M1.66668 0L0.726685 0.94L3.78002 4L0.726685 7.06L1.66668 8L5.66668 4L1.66668 0Z' fill='none' />
  </svg>
)
